import { render, staticRenderFns } from "./merchant-layout.vue?vue&type=template&id=1bc2c699&scoped=true"
import script from "./merchant-layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./merchant-layout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./merchant-layout.vue?vue&type=style&index=0&id=1bc2c699&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc2c699",
  null
  
)

export default component.exports